"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_spring_1 = require("react-spring");
var Close_1 = __importDefault(require("../../icons/Close"));
var theme_1 = __importDefault(require("../../theme"));
var styles_1 = require("./styles");
function SectionedDialog(_a) {
    var show = _a.show, setShow = _a.setShow, header = _a.header, sections = _a.sections, cardStyle = _a.cardStyle;
    var _b = react_1.useState(0), activeSection = _b[0], setActiveSection = _b[1];
    var spring = react_spring_1.useTransition(show, null, {
        delay: 2,
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
    });
    return react_dom_1.createPortal(react_1.default.createElement(react_1.default.Fragment, null, spring.map(function (_a) {
        var item = _a.item, key = _a.key, props = _a.props;
        return item ? (react_1.default.createElement(styles_1.Backdrop, { key: key, style: props, "aria-modal": "true", role: "dialog" },
            react_1.default.createElement(styles_1.Card, { key: key, style: __assign(__assign({}, props), cardStyle) },
                react_1.default.createElement(styles_1.CloseIconContainer, { onClick: setShow },
                    react_1.default.createElement(Close_1.default, { color: theme_1.default.colorsPalette.gray.light, height: "15px" })),
                react_1.default.createElement(styles_1.SectionsContainer, null,
                    typeof header === "string" ? (react_1.default.createElement("h4", { style: { margin: "0 0 15px 0" } }, header)) : (header),
                    sections.map(function (section, index) {
                        return (react_1.default.createElement(styles_1.SectionName, { isSelected: activeSection === index, onClick: function () { return setActiveSection(index); }, key: index }, section.header));
                    })),
                react_1.default.createElement(styles_1.SectionContentContainer, null, sections[activeSection].content)))) : null;
    })), document.body);
}
exports.default = SectionedDialog;
//# sourceMappingURL=index.js.map